import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const EncumbrancesTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <>
      <thead className="table-light">
        <tr>
          <th className="text-left">{t('Encumbrance')}</th>
          <th className="text-center" />
        </tr>
      </thead>
    </>
  );
};

export default EncumbrancesTableHeader;
